import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import Card from '../common/Card';

export default function ParentList({ escolaId }) {
    const [parents, setParents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (escolaId) {
            loadParents();
        }
    }, [escolaId]);

    const loadParents = async () => {
        try {
            setLoading(true);
            // Buscar usuários que estão vinculados a alunos desta escola
            const { data, error } = await supabase
                .from('usuarios')
                .select(`
                    id,
                    nome_completo,
                    telefone,
                    placa_veiculo,
                    pessoas_autorizadas!inner(
                        aluno:alunos!inner(escola_id)
                    )
                `)
                .eq('pessoas_autorizadas.aluno.escola_id', escolaId);

            if (error) throw error;

            // Remover duplicados (um pai pode ter vários filhos)
            const uniqueParents = Array.from(new Set(data.map(p => p.id)))
                .map(id => data.find(p => p.id === id));

            setParents(uniqueParents || []);
        } catch (error) {
            console.error('Erro ao carregar pais:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="bg-white p-6 rounded-3xl shadow-sm border">
                <h2 className="text-2xl font-black text-gray-900 tracking-tighter">Base de Responsáveis</h2>
                <p className="text-gray-500 text-sm font-medium">Veja todos os pais e responsáveis vinculados à sua escola</p>
            </div>

            {loading ? (
                <div className="text-center py-10 text-gray-400 font-bold uppercase tracking-widest text-xs">Carregando base de pais...</div>
            ) : parents.length === 0 ? (
                <Card className="text-center py-12">
                    <p className="text-gray-400 font-medium">Nenhum pai vinculado ainda. Eles aparecerão aqui assim que criarem conta e vincularem um aluno.</p>
                </Card>
            ) : (
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {parents.map(p => (
                        <Card key={p.id} className="hover:border-primary transition-all group">
                            <div className="flex items-start justify-between mb-4">
                                <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-lg shadow-inner group-hover:bg-primary/10 transition-colors">
                                    👤
                                </div>
                                {p.placa_veiculo && (
                                    <span className="text-[10px] font-black bg-primary text-white px-2 py-1 rounded-lg shadow-sm">
                                        {p.placa_veiculo}
                                    </span>
                                )}
                            </div>
                            <h3 className="font-bold text-gray-900 leading-tight mb-1">{p.nome_completo}</h3>
                            <a
                                href={`https://wa.me/${p.telefone?.replace(/\D/g, '')}`}
                                target="_blank"
                                rel="noreferrer"
                                className="text-xs font-bold text-primary hover:underline flex items-center gap-1"
                            >
                                📱 WhatsApp
                            </a>
                        </Card>
                    ))}
                </div>
            )}
        </div>
    );
}
